/**
 * 이미지 경로 상수
 * 로고 및 이미지 파일의 경로를 중앙에서 관리합니다.
 * 
 * 환경 변수를 통해 로고 경로를 설정할 수 있습니다:
 * - .env 파일에 REACT_APP_SK_LOGO_PATH 설정
 * - 절대 URL (http:// 또는 https://로 시작): 그대로 사용
 * - 상대 경로 (/로 시작): PUBLIC_URL과 결합
 * - 환경 변수가 없으면 기본값(assets/images/sk_logo.png)을 사용합니다.
 * 
 * 예시:
 * - REACT_APP_SK_LOGO_PATH=https://example.com/logo.png
 * - REACT_APP_SK_LOGO_PATH=/images/logo.png (public 폴더 기준)
 * - REACT_APP_SK_LOGO_PATH=/assets/images/sk_logo.png (public 폴더 기준)
 */

import defaultSkLogo from 'assets/images/sk_logo.png';

/**
 * 환경 변수에서 로고 경로를 가져오고 적절히 처리합니다.
 */
const getLogoPath = (): string => {
  const envPath = process.env.REACT_APP_SK_LOGO_PATH;
  
  if (!envPath) {
    return defaultSkLogo;
  }
  
  // 절대 URL인 경우 (http:// 또는 https://로 시작)
  if (envPath.startsWith('http://') || envPath.startsWith('https://')) {
    return envPath;
  }
  
  // 상대 경로인 경우 (/로 시작) PUBLIC_URL과 결합
  if (envPath.startsWith('/')) {
    const publicUrl = process.env.PUBLIC_URL || '';
    return `${publicUrl}${envPath}`;
  }
  
  // 그 외의 경우는 기본값 사용
  return defaultSkLogo;
};

/**
 * SK hynix 로고 이미지 경로
 * 환경 변수 REACT_APP_SK_LOGO_PATH가 설정되어 있으면 해당 값을 사용하고,
 * 없으면 기본 이미지를 사용합니다.
 */
export const SK_LOGO = getLogoPath();
